import {
  TaxonomyProjectType,
  TaxonomyTheme,
} from '../implementations';

const mappers = {
  project_types: TaxonomyProjectType,
  themes: TaxonomyTheme,
};

export default mappers;
